export const en = {
  // Navigation
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    contact: "Contact",
    getQuote: "Get Quote",
    callNow: "Call Us Now",
  },

  // Navigation - navbar specific
  navbar: {
    home: "Home",
    services: "Services",
    about: "About",
    gallery: "Our Work",
    contact: "Contact",
  },

  // Common
  common: {
    readMore: "Read More",
    submit: "Submit",
    learnMore: "Learn More",
    getQuote: "Get Quote",
    callNow: "Call Now",
    viewAll: "View All",
  },

  // Home Page
  home: {
    hero: {
      title: "Montreal's Premier Landscaping Service",
      subtitle: "Expert Lawn Care Services",
      serving: "Serving the West Island Montreal community for over a decade",
      servingMobile:
        "West Island's most trusted landscaping experts since 2012",
      getQuote: "Get Free Quote",
      callNow: "Call Us Now",
      viewProjects: "View Our Projects",
    },
    services: {
      title: "Top-Tier Landscaping Services in Montreal",
      subtitle:
        "We offer a variety of professional lawn care and landscaping services throughout the West Island Montreal area",
      lawn: {
        title: "Montreal Lawn & Garden Care",
        description:
          "Comprehensive lawn maintenance including mowing, hedge trimming, tree pruning, and seasonal cleanups to keep your Montreal property looking its best.",
      },
      landscape: {
        title: "West Island Landscape Design",
        description:
          "Professional sodding, aeration, fertilization, top dressing, and landscape planning services to transform your outdoor space in Montreal.",
      },
      property: {
        title: "Montreal Property Maintenance",
        description:
          "Complete solutions for Montreal homes including irrigation, drainage systems, pressure washing, gutter cleaning, and hauling services.",
      },
      learnMore: "Learn more about our Montreal services",
      viewAll: "View all Montreal landscaping services",
    },
    stats: {
      clients: "Satisfied Montreal Clients",
      lawns: "Lawns Mowed",
      years: "Years of Experience",
    },
    process: {
      title: "How to Get Your Quote",
      subtitle: "Simple steps to get started with our services",
      step1: {
        title: "Fill out our form",
        description:
          "Click the button below and let us know what services you need.",
      },
      step2: {
        title: "Wait for our response",
        description:
          "We'll contact you as soon as possible after receiving your request.",
      },
      step3: {
        title: "Relax!",
        description:
          "Once we send you a quote, all you need to do is sit back, relax, and let us take care of your lawn!",
      },
      getFreeQuote: "Get your free quote now",
    },
    testimonials: {
      title: "What Our Clients Say",
      homeowner: "Home Owner",
      quote1:
        "Bearz did an excellent job cleaning up my property this fall, removing a ton of leaves, clearing the gutters and trimming bushes/shrubs. They were friendly and punctual and the property looks great!",
      quote2:
        "I have been using Bearz for the past two years and they always deliver! Great communication, reliable and always do a great job. I highly recommend!",
      quote3:
        "Great company!! Highly recommend very happy, great prices! Very respectful workers, always kind and happy to help with all needs. They always do an amazing job with no complaints. Will definitely be continuing with this amazing company!!",
    },
    about: {
      title: "About Bearz Landscaping",
      paragraph1:
        "With over a decade of experience serving the West Island, Bearz Landscaping provides professional landscaping services to both residential and commercial clients.",
      paragraph2:
        "Our team of skilled professionals is passionate about creating beautiful outdoor spaces that enhance your property's value and your quality of life. We take pride in our attention to detail and commitment to customer satisfaction.",
      feature1: "Experienced Team",
      feature2: "Reliable Service",
      feature3: "Quality Results",
      feature4: "Customer Satisfaction",
      learnMore: "Learn More About Us",
    },
    cta: {
      title: "Transform Your Montreal Property Today!",
      subtitle:
        "Contact us today for a free consultation and let's bring your Montreal landscaping vision to life. West Island's most trusted landscaping experts.",
      getQuote: "Get a Free Montreal Quote",
    },
    gallery: {
      title: "Our Montreal Landscaping Projects",
      subtitle:
        "Take a look at the quality and care we bring to every Montreal landscaping project in the West Island area",
      hoverToSeeAfter: "Hover to see after",
      fallCleanup: {
        title: "Fall Cleanup",
        description: "Seasonal property maintenance with complete leaf removal",
      },
      lawnRejuvenation: {
        title: "Lawn Rejuvenation",
        description: "Complete lawn transformation with fresh sod installation",
      },
      lawnRestoration: {
        title: "Lawn Restoration",
        description: "Transformation of uneven lawns into lush green spaces",
      },
      equipment: {
        title: "Professional Equipment",
        description:
          "Our top-of-the-line equipment guarantees quality results for every job",
      },
      project1: {
        title: "Professional Bush Trimming in Montreal",
        description:
          "Precision shaped bushes for a clean, elegant look in Montreal gardens",
      },
      project2: {
        title: "Montreal Hedge Maintenance",
        description:
          "Perfectly trimmed hedges with freshly cut lawn for Montreal properties",
      },
      project3: {
        title: "Montreal Lawn Care Expertise",
        description:
          "Detailed mowing patterns for a luxurious aesthetic in Montreal yards",
      },
      project4: {
        title: "Montreal Waterfront Landscaping",
        description:
          "Specialized care for waterfront properties in the Montreal region",
      },
      project5: {
        title: "Montreal Complete Lawn Service",
        description: "Comprehensive maintenance for a pristine Montreal yard",
      },
      project6: {
        title: "Montreal Lawn Maintenance",
        description:
          "Regular mowing for healthy, beautiful grass in Montreal homes",
      },
      requestService: "Request a Service in Montreal",
    },
  },

  // About Page
  about: {
    title: "About Bearz Landscaping",
    subtitle: "Professional landscaping services you can trust",
    story: {
      title: "Our Story",
      content:
        "Founded over a decade ago, Bearz Landscaping has been proudly serving Montreal's West Island with exceptional landscaping and property maintenance services. What started as a small local business has grown into a trusted name in the community, known for our commitment to quality, reliability, and customer satisfaction.",
    },
    mission: {
      title: "Our Mission",
      content:
        "To provide professional, reliable, and affordable landscaping services that enhance the beauty and value of your property while exceeding your expectations.",
    },
    values: {
      title: "Our Values",
      quality: "Quality Workmanship",
      reliability: "Reliability & Trust",
      satisfaction: "Customer Satisfaction",
      professionalism: "Professionalism",
    },
  },

  // Gallery Page
  gallery: {
    title: "Our Work Gallery",
    subtitle: "Browse through our portfolio of completed projects",
    categories: {
      all: "All Projects",
      landscaping: "Landscaping",
      maintenance: "Maintenance",
      cleanup: "Cleanup",
      commercial: "Commercial",
    },
    viewMore: "View More Projects",
  },

  // Footer
  footer: {
    description:
      "Providing premium landscaping services to the West Island for over a decade. Quality, reliability, and customer satisfaction are at the heart of everything we do.",
    quickLinks: "Quick Links",
    services: "Services",
    servicesList: {
      lawn: "Lawn Maintenance",
      landscaping: "Landscaping",
      hedge: "Hedge Trimming",
      pressure: "Pressure Washing",
      allServices: "All Services",
    },
    contactUs: "Contact Us",
    hours: {
      weekdays: "Monday - Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      closed: "Closed",
    },
    servicedAreas: {
      title: "Montreal Landscaping Services in:",
      list: "Beaconsfield, Pointe-Claire, Kirkland, Dollard-des-Ormeaux, Pierrefonds, West Island, and surrounding areas",
    },
    copyright: "Bearz Landscaping. All rights reserved.",
    tagline:
      "Premium landscaping services in Montreal's West Island since 2012",
    requestQuote: "Request a Montreal Quote",
  },

  // Contact Page
  contact: {
    title: "Contact Us",
    subtitle: "Send us a message and we'll respond as soon as possible",
    form: {
      title: "FILL IN THIS FORM TO GET YOUR FREE QUOTE!",
      subtitle:
        "Fill out the form below and we'll get back to you within 24 hours",
      name: "Full Name",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      postalCode: "Postal Code",
      service: "Desired Service",
      services: "Desired Service",
      servicesNote: "Select all that apply",
      message: "Special Requests or Comments",
      specialRequest: "Special Requests or Comments",
      marketingConsent: "I agree to receive marketing communications",
      submit: "Submit Quote Request",
      submitting: "Sending...",
      success: "Thank you! We'll be in touch within 24 hours.",
      successTitle: "Quote Request Submitted Successfully!",
      successDescription:
        "Thank you for your interest! You'll receive a confirmation email shortly. We'll review your request and contact you within 24 hours. For urgent matters, please call us at (514) 979-8020.",
      error: "Error sending message. Please try again.",
      errorTitle: "Submission Error",
      selectService: "Please select at least one service.",
      required: "Required",
      dismiss: "Dismiss",
      serviceOptions: {
        lawnMowing: "Lawn Mowing",
        hedgeTrimming: "Hedge Trimming",
        cleanups: "Cleanups (Spring/Fall)",
        aeration: "Aeration",
        fertilization: "Fertilization",
        topdressing: "Topdressing",
        treePruning: "Tree Pruning",
        sodding: "Sodding",
        delivery: "Delivery of Vrac",
        exteriorPainting: "Exterior Painting",
        pressureWashing: "Pressure Washing",
        eavestrough: "Eavestrough/Gutter Cleaning",
        transportation: "Transportation",
        landscaping: "Landscaping/Unitstone",
        paveUni: "Pavé Uni & Releveling",
        excavation: "Excavation",
        snowRemoval: "Snow Removal",
      },
    },
    serviceOptions: {
      lawnMowing: "Lawn Mowing",
      hedgeTrimming: "Hedge Trimming",
      cleanups: "Cleanups (Spring/Fall)",
      aeration: "Aeration",
      fertilization: "Fertilization",
      topdressing: "Topdressing",
      treePruning: "Tree Pruning",
      sodding: "Sodding",
      delivery: "Delivery of Vrac",
      exteriorPainting: "Exterior Painting",
      pressureWashing: "Pressure Washing",
      eavestrough: "Eavestrough/Gutter Cleaning",
      transportation: "Transportation",
      landscaping: "Landscaping/Unitstone",
      paveUni: "Pavé Uni & Releveling",
      excavation: "Excavation",
      snowRemoval: "Snow Removal",
    },
    info: {
      title: "Get In Touch",
      subtitle: "Ready to transform your property? Contact us today!",
      phone: "514-979-8020",
      email: "mattellerton.landscaping@gmail.com",
      hours: "Mon-Fri: 9AM-5PM",
      areas: "Serving West Island Montreal",
    },
    contactInfo: {
      phone: "Phone",
      phoneNumber: "514-979-8020",
      email: "Email",
      emailAddress: "mattellerton.landscaping@gmail.com",
      location: "Location",
      address: "Montreal, Quebec",
    },
    confirmationEmail: {
      fromFacebookAd: "From Facebook Ad",
    },
  },

  // Hero Section
  hero: {
    title: "Professional Landscaping Services in Montreal",
    subtitle:
      "Transform your outdoor space with expert landscaping, lawn care, and property maintenance services",
    cta: "Get Free Quote",
    phone: "514-979-8020",
    trustedBy: "Trusted by 500+ Montreal homeowners",
  },

  // Services
  services: {
    header: {
      title: "Our Professional Services",
      subtitle: "Comprehensive landscaping solutions tailored to your needs",
    },
    cta: {
      title: "Ready to Transform Your Property?",
      subtitle:
        "Get a free consultation and quote for your landscaping project today",
      getQuote: "Get Free Quote",
    },
    callNow: "Call Now",
    callPhone: "Call: 514-979-8020",

    residential: {
      title: "Residential Services",
      subtitle: "Professional landscaping services for homeowners",
      services: {
        lawnCare: {
          title: "Lawn Care & Maintenance",
          description:
            "Keep your lawn healthy and beautiful with our professional lawn care services including mowing, fertilizing, and seasonal treatments.",
        },
        hedgeTree: {
          title: "Hedge & Tree Services",
          description:
            "Expert pruning, trimming, and care for your trees and hedges to maintain health and enhance your property's appearance.",
        },
        seasonal: {
          title: "Seasonal Cleanup",
          description:
            "Comprehensive spring and fall cleanup services to prepare your landscape for each season.",
        },
        treatments: {
          title: "Lawn Treatments",
          description:
            "Professional fertilization and pest management to keep your lawn in perfect condition.",
        },
      },
      features: {
        professional: "Professional equipment and techniques",
        customized: "Customized service plans",
        regular: "Regular maintenance programs available",
      },
      getQuoteForService: "Get Quote for This Service",
      banner: {
        title: "Ready to Transform Your Home's Landscape?",
        subtitle:
          "Our residential landscaping experts are ready to bring your vision to life. Get a personalized quote today!",
        cta: "Get Your Free Residential Quote",
      },
    },

    commercial: {
      title: "Commercial Services",
      subtitle:
        "Professional landscaping solutions for businesses and commercial properties",
      services: {
        sodding: {
          title: "Sodding & Landscaping",
          description:
            "Professional sodding services and landscaping solutions including interlocking installation to instantly transform your outdoor space.",
        },
        delivery: {
          title: "Delivery Services",
          description:
            "Bulk material delivery and hauling services for all your landscaping needs.",
        },
        property: {
          title: "Property Maintenance",
          description:
            "Complete property solutions including pressure washing, exterior painting, and gutter cleaning.",
        },
      },
      requestQuote: "Request Quote",
      callForDetails: "Call for Details",
      banner: {
        title: "Need Commercial Landscaping Solutions?",
        subtitle:
          "Professional maintenance and landscaping services to enhance your business property and create a lasting impression.",
        cta: "Get Commercial Quote",
      },
    },

    specialty: {
      title: "Specialty Services",
      subtitle:
        "Additional services to enhance and maintain your outdoor space",
      services: {
        painting: {
          title: "Exterior Painting",
          description:
            "High-quality exterior painting services to enhance and protect your home's appearance while increasing its value.",
        },
        pressure: {
          title: "Pressure Washing",
          description:
            "Professional pressure washing services to clean driveways, decks, patios, and siding, removing dirt, grime, mold, and mildew.",
        },
        gutter: {
          title: "Gutter Cleaning",
          description:
            "Regular gutter cleaning and maintenance to prevent water damage, leaks, and foundation issues.",
        },
        transportation: {
          title: "Transportation Services",
          description:
            "Reliable hauling services for landscaping materials, equipment, and debris removal to support your project.",
        },
      },
      banner: {
        title: "Need Additional Property Services?",
        subtitle:
          "From pressure washing to gutter cleaning, we offer comprehensive property maintenance services to keep your home or business looking its best.",
        cta: "Request Specialty Services",
      },
    },

    detailed: {
      title: "Detailed Service Pages",
      subtitle: "Learn more about our comprehensive landscaping services",
      services: {
        treePruning: {
          title: "Tree Pruning",
          description:
            "Professional tree pruning and care services for healthy, beautiful trees.",
        },
        gardening: {
          title: "Garden Design & Maintenance",
          description: "Custom garden design and ongoing maintenance services.",
        },
        grassCutting: {
          title: "Grass Cutting",
          description:
            "Professional grass cutting and lawn maintenance services.",
        },
        springFallCleanup: {
          title: "Seasonal Cleanup",
          description:
            "Spring and fall cleanup services for year-round property maintenance.",
        },
        parkingLotCleaning: {
          title: "Parking Lot Cleaning",
          description:
            "Commercial parking lot cleaning and maintenance services.",
        },
        hedgeTrimming: {
          title: "Hedge Trimming",
          description: "Precision hedge trimming and shaping services.",
        },
        sodInstallation: {
          title: "Sod Installation",
          description:
            "Professional sod installation for instant lawn transformation.",
        },
        relevelling: {
          title: "Concrete Releveling",
          description:
            "Professional concrete releveling services for driveways, walkways, stairs, and lawn surfaces.",
        },
        paveWalkways: {
          title: "Pavé & Walkways",
          description:
            "Beautiful hardscaping solutions with pavers and walkways.",
        },
        paveUniReleveling: {
          title: "Pavé Uni & Releveling",
          description:
            "Expert interlocking paver installation and surface releveling for driveways and walkways.",
        },
        excavation: {
          title: "Excavation",
          description:
            "Professional excavation and site preparation services for residential and commercial projects.",
        },
        snowRemoval: {
          title: "Snow Removal",
          description:
            "Reliable driveway plowing and walkway shoveling services to keep your property safe all winter.",
        },
      },
      getQuote: "Get Quote",
      learnMore: "Learn More",
      notFound: {
        title: "Don't See What You're Looking For?",
        subtitle:
          "We offer many specialized services beyond what's listed. Contact us to discuss your specific needs.",
        discuss: "Discuss Your Project",
      },
    },
  },

  // Grass Cutting Service Page
  grassCutting: {
    title: "Professional Grass Cutting Services",
    subtitle:
      "Keep your lawn pristine with our reliable and professional grass cutting and lawn maintenance services.",
    overviewTitle: "Expert Grass Cutting and Lawn Maintenance",
    overviewDescription:
      "Our experienced technicians provide consistent and reliable grass cutting services that keep your lawn healthy, beautiful, and well-maintained throughout the growing season. We use professional equipment and proper techniques to ensure the best results.",

    features: {
      regular: {
        title: "Regular Cutting Schedules",
        description:
          "Consistent cutting schedules to maintain optimal grass health and appearance.",
      },
      equipment: {
        title: "Professional Equipment",
        description:
          "High-quality, well-maintained equipment for precise and efficient cutting.",
      },
      techniques: {
        title: "Proper Cutting Techniques",
        description:
          "Correct cutting height and techniques to promote healthy grass growth.",
      },
      cleanup: {
        title: "Complete Cleanup",
        description:
          "Thorough cleanup of all grass clippings and debris after each service.",
      },
      weather: {
        title: "Weather-Dependent Scheduling",
        description:
          "Flexible scheduling based on weather conditions for optimal results.",
      },
      mulching: {
        title: "Mulching Options",
        description:
          "Natural mulching options to return nutrients to your lawn.",
      },
      edging: {
        title: "Precision Edging",
        description:
          "Clean, precise edging around walkways, driveways, and garden beds for a polished look.",
      },
      flexible: {
        title: "Flexible Scheduling",
        description:
          "Customizable cutting schedules to fit your lifestyle and lawn's needs.",
      },
      seasonal: {
        title: "Seasonal Adjustments",
        description:
          "Cutting height and frequency adjustments based on seasonal growth patterns.",
      },
    },

    benefits: [
      "Improved lawn health and appearance",
      "Consistent, professional results",
      "Time savings for property owners",
      "Enhanced property curb appeal",
      "Optimal grass growth promotion",
    ],

    processTitle: "Our Grass Cutting Process",
    processDescription:
      "Professional grass cutting services for pristine lawn maintenance",
    process: {
      step1: {
        title: "Lawn Assessment",
        description:
          "We assess your lawn's condition and cutting requirements.",
      },
      step2: {
        title: "Custom Schedule",
        description:
          "We create a cutting schedule tailored to your lawn's needs.",
      },
      step3: {
        title: "Professional Cutting",
        description:
          "Our team performs precise cutting using professional equipment.",
      },
      step4: {
        title: "Complete Cleanup",
        description:
          "We clean up all debris and leave your property neat and tidy.",
      },
    },

    ctaMiddle: {
      title: "Ready for Professional Lawn Care?",
      subtitle:
        "Our grass cutting experts are ready to keep your lawn looking its best.",
      getQuote: "Get Free Grass Cutting Quote",
      callNow: "Call for Lawn Care Consultation",
    },

    cta: {
      title: "Get Your Perfect Lawn Today",
      subtitle:
        "Contact us for professional grass cutting services that will keep your lawn in perfect condition all year long.",
      getQuote: "Start Your Lawn Care Service",
    },
  },

  // Spring/Fall Cleanup Service Page
  springFallCleanup: {
    title: "Professional Spring & Fall Cleanup Services",
    subtitle:
      "Prepare your property for the changing seasons with our comprehensive spring and fall cleanup services.",
    overviewTitle: "Expert Seasonal Property Cleanup",
    overviewDescription:
      "Our comprehensive spring and fall cleanup services prepare your property for the changing seasons. From leaf removal to debris cleanup, we ensure your landscape is ready for what's ahead.",

    features: {
      spring: {
        title: "Spring Cleanup",
        description:
          "Complete spring preparation including debris removal and garden bed maintenance.",
      },
      fall: {
        title: "Fall Cleanup",
        description:
          "Thorough fall cleanup including leaf removal and winterization services.",
      },
      debris: {
        title: "Debris Removal",
        description:
          "Complete removal of all yard debris, branches, and seasonal waste.",
      },
      pruning: {
        title: "Pruning & Trimming",
        description:
          "Seasonal pruning and trimming to promote healthy plant growth.",
      },
      mulching: {
        title: "Mulching Services",
        description:
          "Fresh mulch application to protect plants and enhance appearance.",
      },
      winterization: {
        title: "Winterization",
        description:
          "Complete property preparation for winter weather protection.",
      },
    },

    benefits: [
      "Complete seasonal property preparation",
      "Enhanced curb appeal year-round",
      "Protection for plants and landscaping",
      "Time savings for property owners",
      "Professional equipment and expertise",
      "Comprehensive debris removal",
    ],

    processTitle: "Our Seasonal Cleanup Process",
    processDescription:
      "Professional spring and fall cleanup services for year-round property maintenance",
    process: {
      step1: {
        title: "Property Assessment",
        description:
          "We evaluate your property's seasonal cleanup needs and requirements.",
      },
      step2: {
        title: "Custom Plan",
        description:
          "We create a cleanup plan tailored to your property and season.",
      },
      step3: {
        title: "Professional Cleanup",
        description:
          "Our team performs comprehensive cleanup using professional equipment.",
      },
      step4: {
        title: "Complete Removal",
        description:
          "We remove all debris and leave your property clean and prepared.",
      },
    },

    ctaMiddle: {
      title: "Ready for Seasonal Property Care?",
      subtitle:
        "Our cleanup experts are ready to prepare your property for the changing seasons.",
      getQuote: "Get Free Cleanup Quote",
      callNow: "Call for Cleanup Consultation",
    },

    cta: {
      title: "Get Your Property Season-Ready Today",
      subtitle:
        "Contact us for professional spring and fall cleanup services that will keep your property looking its best all year long.",
      getQuote: "Start Your Seasonal Cleanup Service",
    },
  },

  // Hedge Trimming Service Page
  hedgeTrimming: {
    title: "Professional Hedge Trimming Services",
    subtitle:
      "Keep your hedges neat, healthy, and beautifully shaped with our expert hedge trimming and maintenance services.",
    overviewTitle: "Expert Hedge Trimming and Shaping",
    overviewDescription:
      "Our skilled technicians provide precise hedge trimming services that maintain the health and appearance of your hedges. We use professional equipment and proper techniques to ensure clean cuts and promote healthy growth.",

    features: {
      precision: {
        title: "Precision Cutting",
        description:
          "Accurate cutting techniques that promote healthy growth and beautiful shape.",
      },
      shaping: {
        title: "Custom Shaping",
        description:
          "Expert shaping services to create and maintain desired hedge forms.",
      },
      timing: {
        title: "Optimal Timing",
        description:
          "Timing cuts for the best health and growth of your hedges.",
      },
      cleanup: {
        title: "Complete Cleanup",
        description:
          "Thorough cleanup of all trimmings and debris after each service.",
      },
      maintenance: {
        title: "Regular Maintenance",
        description:
          "Ongoing maintenance schedules to keep hedges in perfect condition.",
      },
      restoration: {
        title: "Restoration Services",
        description:
          "Rehabilitation of overgrown or neglected hedges back to health.",
      },
    },

    benefits: [
      "Enhanced property curb appeal",
      "Improved hedge health and growth",
      "Professional, neat appearance",
      "Increased property value",
      "Time savings for property owners",
      "Expert shaping and maintenance",
    ],

    processTitle: "Our Hedge Trimming Process",
    processDescription:
      "Professional hedge trimming services for beautiful, healthy hedges",
    process: {
      step1: {
        title: "Hedge Assessment",
        description:
          "We evaluate your hedges' condition and trimming requirements.",
      },
      step2: {
        title: "Custom Plan",
        description:
          "We create a trimming plan tailored to your hedge types and goals.",
      },
      step3: {
        title: "Professional Trimming",
        description:
          "Our team performs precise trimming using professional equipment.",
      },
      step4: {
        title: "Complete Cleanup",
        description:
          "We clean up all debris and leave your property neat and tidy.",
      },
    },

    ctaMiddle: {
      title: "Ready for Professional Hedge Care?",
      subtitle:
        "Our hedge trimming experts are ready to keep your hedges looking their best.",
      getQuote: "Get Free Hedge Trimming Quote",
      callNow: "Call for Hedge Care Consultation",
    },

    cta: {
      title: "Get Beautiful, Healthy Hedges Today",
      subtitle:
        "Contact us for professional hedge trimming services that will keep your hedges in perfect condition all year long.",
      getQuote: "Start Your Hedge Care Service",
    },
  },

  // Tree Pruning Service Page
  treePruning: {
    title: "Professional Tree Pruning Services",
    subtitle:
      "Keep your trees healthy, safe, and beautiful with our expert tree pruning and care services.",
    overviewTitle: "Expert Tree Care and Pruning",
    overviewDescription:
      "Our certified arborists provide professional tree pruning services that promote tree health, improve safety, and enhance the beauty of your landscape. We use proper techniques and equipment to ensure the long-term health of your trees.",

    features: {
      assessment: {
        title: "Tree Health Assessment",
        description:
          "Comprehensive evaluation of tree health and structural integrity.",
      },
      safety: {
        title: "Safety-First Approach",
        description:
          "Professional safety measures and insured services for peace of mind.",
      },
      techniques: {
        title: "Proper Pruning Techniques",
        description:
          "Expert pruning methods that promote healthy growth and tree longevity.",
      },
      cleanup: {
        title: "Complete Cleanup",
        description:
          "Thorough cleanup and removal of all debris after pruning.",
      },
      insurance: {
        title: "Fully Insured",
        description:
          "Complete insurance coverage for property protection and peace of mind.",
      },
      consultation: {
        title: "Expert Consultation",
        description:
          "Professional advice on tree care and maintenance recommendations.",
      },
    },

    benefits: [
      "Improved tree health and longevity",
      "Enhanced property safety",
      "Increased property value",
      "Better landscape aesthetics",
      "Prevention of tree diseases",
      "Professional expert care",
    ],

    processTitle: "Our Tree Pruning Process",
    processDescription:
      "Professional tree pruning services for healthy, beautiful trees",

    timing: {
      title: "When to Prune Your Trees",
      spring: {
        title: "Spring Pruning",
        description:
          "Ideal time for most deciduous trees, promoting healthy growth.",
      },
      emergency: {
        title: "Emergency Pruning",
        description: "Immediate attention for damaged or hazardous branches.",
      },
      specific: {
        title: "Species-Specific Timing",
        description:
          "Customized timing based on your specific tree species and needs.",
      },
    },

    ctaMiddle: {
      title: "Ready for Professional Tree Care?",
      subtitle:
        "Our certified arborists are ready to keep your trees healthy and beautiful.",
      getQuote: "Get Free Tree Pruning Quote",
      callNow: "Call for Tree Care Consultation",
    },

    cta: {
      title: "Get Healthy, Beautiful Trees Today",
      subtitle:
        "Contact us for professional tree pruning services that will keep your trees in perfect condition all year long.",
      getQuote: "Start Your Tree Care Service",
    },
  },

  // Relevelling Service Page
  relevelling: {
    title: "Professional Concrete Releveling Services",
    subtitle:
      "Transform uneven driveways, walkways, stairs, and concrete surfaces with our expert releveling and concrete lifting services.",
    overviewTitle: "Expert Concrete Releveling and Surface Restoration",
    overviewDescription:
      "Our professional releveling services address uneven concrete surfaces, sunken driveways, tilted walkways, and settling issues on stairs and patios. We also provide lawn leveling services to create smooth, level surfaces that are safer and more attractive.",

    features: {
      assessment: {
        title: "Surface Assessment",
        description:
          "Comprehensive evaluation of concrete surfaces and structural requirements.",
      },
      grading: {
        title: "Professional Releveling",
        description:
          "Expert releveling techniques for driveways, walkways, stairs, and concrete surfaces.",
      },
      soil: {
        title: "Foundation Preparation",
        description:
          "Quality soil and base preparation for long-lasting concrete stability.",
      },
      compaction: {
        title: "Proper Compaction",
        description:
          "Appropriate base compaction to prevent future settling and sinking issues.",
      },
      seeding: {
        title: "Concrete Repair & Lawn Restoration",
        description:
          "Professional concrete repair and lawn restoration services after releveling work.",
      },
      drainage: {
        title: "Drainage Solutions",
        description:
          "Proper drainage solutions to prevent water damage and concrete settling.",
      },
    },

    benefits: [
      "Safe, even concrete surfaces",
      "Improved drainage around driveways and walkways",
      "Enhanced property safety and accessibility",
      "Increased property value and curb appeal",
      "Prevention of further settling damage",
      "Professional expert service",
    ],

    processTitle: "Our Concrete Releveling Process",
    processDescription:
      "Professional releveling services for driveways, walkways, stairs, and lawn surfaces",
    process: {
      step1: {
        title: "Site Assessment",
        description:
          "We evaluate your concrete surfaces, driveways, stairs, and releveling requirements.",
      },
      step2: {
        title: "Releveling Plan",
        description:
          "We create a detailed releveling plan for optimal structural results.",
      },
      step3: {
        title: "Professional Releveling",
        description:
          "Our team performs precise releveling using professional concrete lifting and grading equipment.",
      },
      step4: {
        title: "Surface Restoration",
        description:
          "We complete the process with concrete repair, sealing, or lawn restoration as needed.",
      },
    },

    ctaMiddle: {
      title: "Ready for Professional Releveling?",
      subtitle:
        "Our releveling experts are ready to transform your uneven concrete surfaces and create safe, beautiful areas.",
      getQuote: "Get Free Releveling Quote",
      callNow: "Call for Surface Assessment",
    },

    cta: {
      title: "Get Your Perfect Level Surfaces Today",
      subtitle:
        "Contact us for professional concrete releveling and lawn leveling services that will transform your property.",
      getQuote: "Start Your Releveling Project",
    },
  },

  // Parking Lot Cleaning Service Page
  parkingLotCleaning: {
    title: "Professional Parking Lot Cleaning Services",
    subtitle:
      "Keep your commercial parking areas clean, safe, and professional with our comprehensive parking lot cleaning services.",
    overviewTitle: "Expert Commercial Parking Lot Maintenance",
    overviewDescription:
      "Our professional parking lot cleaning services ensure your commercial property maintains a clean, safe, and professional appearance that makes a positive impression on customers and visitors.",

    features: {
      sweeping: {
        title: "Power Sweeping",
        description:
          "Professional power sweeping to remove debris, leaves, and litter.",
      },
      pressure: {
        title: "Pressure Washing",
        description:
          "High-pressure washing to remove stains, grime, and buildup.",
      },
      debris: {
        title: "Debris Removal",
        description:
          "Complete removal of all parking lot debris, trash, and unwanted materials.",
      },
      maintenance: {
        title: "Regular Maintenance",
        description:
          "Scheduled maintenance programs to keep properties consistently clean.",
      },
      seasonal: {
        title: "Seasonal Services",
        description:
          "Specialized seasonal cleaning including leaf removal and winter preparation.",
      },
      commercial: {
        title: "Commercial Solutions",
        description: "Comprehensive commercial property maintenance solutions.",
      },
    },

    benefits: [
      "Professional business appearance",
      "Enhanced customer experience",
      "Improved safety and accessibility",
      "Compliance with regulations",
      "Extended pavement life",
      "Cost-effective maintenance",
    ],

    processTitle: "Our Parking Lot Cleaning Process",
    processDescription:
      "Professional parking lot cleaning services for commercial properties",
    process: {
      step1: {
        title: "Property Assessment",
        description:
          "We evaluate your parking lot's cleaning and maintenance needs.",
      },
      step2: {
        title: "Service Schedule",
        description:
          "We create a maintenance schedule tailored to your business needs.",
      },
      step3: {
        title: "Professional Cleaning",
        description:
          "Our team performs thorough cleaning using commercial equipment.",
      },
      step4: {
        title: "Quality Assurance",
        description:
          "We ensure all areas meet our high standards for cleanliness.",
      },
    },

    ctaMiddle: {
      title: "Ready for Professional Property Care?",
      subtitle:
        "Our commercial cleaning experts are ready to keep your parking lot looking its best.",
      getQuote: "Get Free Commercial Quote",
      callNow: "Call for Property Assessment",
    },

    cta: {
      title: "Get Professional Parking Lot Care Today",
      subtitle:
        "Contact us for comprehensive parking lot cleaning services that will keep your commercial property looking professional.",
      getQuote: "Start Your Commercial Service",
    },
  },

  // Gardening Service Page
  gardening: {
    title: "Professional Garden Design & Maintenance Services",
    subtitle:
      "Create and maintain beautiful gardens with our expert garden design, planting, and ongoing maintenance services.",
    overviewTitle: "Expert Garden Design and Care",
    overviewDescription:
      "Our professional gardening services combine creative design with expert plant knowledge to create and maintain beautiful, thriving gardens that enhance your property's beauty and value.",

    features: {
      design: {
        title: "Garden Design",
        description:
          "Custom garden design tailored to your space and preferences.",
      },
      planting: {
        title: "Professional Planting",
        description:
          "Expert plant selection and installation for optimal growth.",
      },
      maintenance: {
        title: "Garden Maintenance",
        description:
          "Ongoing maintenance to keep your garden healthy and beautiful.",
      },
      seasonal: {
        title: "Seasonal Care",
        description:
          "Seasonal garden care including pruning, fertilizing, and cleanup.",
      },
      consultation: {
        title: "Expert Consultation",
        description: "Professional advice on plant selection and garden care.",
      },
      soil: {
        title: "Soil Health",
        description:
          "Soil testing and amendment for optimal plant health and growth.",
      },
    },

    benefits: [
      "Beautiful, custom garden designs",
      "Expert plant selection and care",
      "Increased property value",
      "Year-round garden beauty",
      "Professional maintenance service",
      "Sustainable gardening practices",
    ],

    processTitle: "Our Garden Design Process",
    processDescription:
      "Professional garden design and maintenance services for beautiful outdoor spaces",
    process: {
      step1: {
        title: "Design Consultation",
        description:
          "We discuss your vision and assess your garden space and needs.",
      },
      step2: {
        title: "Custom Design",
        description:
          "We create a custom garden design plan tailored to your space.",
      },
      step3: {
        title: "Professional Installation",
        description:
          "Our team installs plants and features according to the design.",
      },
      step4: {
        title: "Ongoing Care",
        description:
          "We provide ongoing maintenance to keep your garden thriving.",
      },
    },

    ctaMiddle: {
      title: "Ready for Your Dream Garden?",
      subtitle:
        "Our garden design experts are ready to create the perfect outdoor space for you.",
      getQuote: "Get Free Garden Design Quote",
      callNow: "Call for Design Consultation",
    },

    cta: {
      title: "Get Your Beautiful Garden Today",
      subtitle:
        "Contact us for professional garden design and maintenance services that will transform your outdoor space.",
      getQuote: "Start Your Garden Project",
    },
  },

  // Pavé & Walkways Service Page
  paveWalkways: {
    title: "Professional Pavé & Walkway Installation",
    subtitle:
      "Transform your outdoor spaces with beautiful, durable pavé and walkway installations that enhance your property's appeal.",
    overviewTitle: "Expert Hardscaping Solutions",
    overviewDescription:
      "Our professional pavé and walkway installation services create stunning, functional outdoor spaces using high-quality materials and expert craftsmanship for lasting beauty and durability.",

    features: {
      design: {
        title: "Custom Design",
        description:
          "Custom hardscaping designs tailored to your property and style.",
      },
      materials: {
        title: "Quality Materials",
        description:
          "Premium pavé stones and materials for durability and beauty.",
      },
      installation: {
        title: "Expert Installation",
        description:
          "Professional installation techniques for long-lasting results.",
      },
      drainage: {
        title: "Proper Drainage",
        description: "Engineered drainage solutions to prevent water issues.",
      },
      finishing: {
        title: "Professional Finishing",
        description:
          "Expert finishing touches and final details for perfect results.",
      },
      maintenance: {
        title: "Maintenance Service",
        description:
          "Ongoing maintenance to keep your hardscaping looking its best.",
      },
      warranty: {
        title: "Quality Warranty",
        description: "Comprehensive warranty on materials and workmanship.",
      },
    },

    benefits: [
      "Enhanced property curb appeal",
      "Increased property value",
      "Durable, long-lasting surfaces",
      "Low maintenance requirements",
      "Custom design options",
      "Professional expert installation",
    ],

    processTitle: "Our Installation Process",
    processDescription:
      "Professional pavé and walkway installation for beautiful outdoor spaces",
    process: {
      step1: {
        title: "Design Consultation",
        description:
          "We discuss your vision and assess your space for the perfect design.",
      },
      step2: {
        title: "Material Selection",
        description:
          "We help you choose the best materials for your project and budget.",
      },
      step3: {
        title: "Professional Installation",
        description:
          "Our team installs your pavé and walkways with expert precision.",
      },
      step4: {
        title: "Final Inspection",
        description:
          "We conduct a thorough inspection to ensure perfect results.",
      },
    },

    ctaMiddle: {
      title: "Ready for Beautiful Hardscaping?",
      subtitle:
        "Our hardscaping experts are ready to transform your outdoor space with stunning pavé and walkways.",
      getQuote: "Get Free Hardscaping Quote",
      callNow: "Call for Design Consultation",
    },

    cta: {
      title: "Get Your Dream Hardscaping Today",
      subtitle:
        "Contact us for professional pavé and walkway installation that will enhance your property's beauty and value.",
      getQuote: "Start Your Hardscaping Project",
    },
  },

  // Pavé Uni & Releveling Service Page
  paveUniReleveling: {
    title: "Pavé Uni & Releveling Services",
    subtitle:
      "Professional interlocking paver installation and surface releveling for driveways, walkways, and patios across the West Island.",
    overviewTitle: "Expert Interlocking Pavers & Surface Leveling",
    overviewDescription:
      "We specialize in installing beautiful interlocking pavé uni for driveways, walkways, and patios, as well as releveling uneven surfaces that have shifted or settled over time. Our team delivers lasting results with quality materials and precise workmanship.",

    features: {
      installation: {
        title: "Pavé Uni Installation",
        description:
          "Professional installation of interlocking pavers for driveways, walkways, patios, and pool surrounds.",
      },
      releveling: {
        title: "Surface Releveling",
        description:
          "Expert releveling of sunken or uneven paver surfaces to restore a safe, level finish.",
      },
      design: {
        title: "Custom Patterns & Colours",
        description:
          "Wide selection of paver styles, patterns, and colours to complement your home's exterior.",
      },
      base: {
        title: "Proper Base Preparation",
        description:
          "Thorough excavation and compacted gravel base installation to prevent future settling.",
      },
      drainage: {
        title: "Drainage Solutions",
        description:
          "Engineered slope and drainage to channel water away and protect your paver investment.",
      },
      edging: {
        title: "Edge Restraints & Finishing",
        description:
          "Durable edge restraints and precision jointing sand for a polished, long-lasting result.",
      },
    },

    benefits: [
      "Increased curb appeal and property value",
      "Durable surfaces that withstand Montreal winters",
      "Low-maintenance — no cracking like poured concrete",
      "Individual pavers can be replaced if damaged",
      "Custom designs tailored to your home",
      "Safe, even surfaces that prevent trip hazards",
    ],

    processTitle: "Our Pavé Uni & Releveling Process",
    processDescription:
      "From consultation to final inspection, we handle every detail",
    process: {
      step1: {
        title: "On-Site Consultation",
        description:
          "We assess your space, discuss design options, and provide a detailed estimate.",
      },
      step2: {
        title: "Excavation & Base Prep",
        description:
          "We excavate to the required depth and install a compacted gravel base for stability.",
      },
      step3: {
        title: "Paver Installation",
        description:
          "Our crew installs pavers to your chosen pattern with precise cuts and consistent joints.",
      },
      step4: {
        title: "Finishing & Clean-Up",
        description:
          "We apply jointing sand, compact the surface, and leave your property spotless.",
      },
    },

    ctaMiddle: {
      title: "Ready for a Beautiful New Driveway or Walkway?",
      subtitle:
        "Our pavé uni experts are ready to transform your outdoor surfaces with quality that lasts.",
      getQuote: "Get Free Pavé Uni Quote",
      callNow: "Call for a Consultation",
    },

    cta: {
      title: "Transform Your Outdoor Surfaces Today",
      subtitle:
        "Contact us for professional pavé uni installation and releveling services across the West Island of Montreal.",
      getQuote: "Start Your Pavé Uni Project",
    },
  },

  // Excavation Service Page
  excavation: {
    title: "Professional Excavation Services",
    subtitle:
      "Reliable excavation and site preparation for residential and commercial projects across the West Island of Montreal.",
    overviewTitle: "Expert Excavation & Site Preparation",
    overviewDescription:
      "Our experienced team provides professional excavation services for a wide range of projects — from driveway and patio preparation to drainage work, foundation digging, and land clearing. We operate modern equipment to get the job done efficiently and safely.",

    features: {
      sitePreparing: {
        title: "Site Preparation",
        description:
          "Full site clearing and preparation before construction, landscaping, or paving projects begin.",
      },
      grading: {
        title: "Grading & Leveling",
        description:
          "Precise grading to establish proper slopes and level surfaces for drainage and stability.",
      },
      trenchDig: {
        title: "Trenching",
        description:
          "Accurate trenching for drainage pipes, utility lines, irrigation systems, and French drains.",
      },
      landClearing: {
        title: "Land Clearing",
        description:
          "Removal of stumps, rocks, old material, and debris to prepare land for new projects.",
      },
      foundation: {
        title: "Foundation Excavation",
        description:
          "Careful excavation for foundations, retaining walls, and below-grade structures.",
      },
      safety: {
        title: "Safe Equipment Operation",
        description:
          "Certified operators and proper safety protocols on every job site, big or small.",
      },
    },

    benefits: [
      "Modern equipment for efficient, precise digging",
      "Experienced, certified operators",
      "Proper grading to prevent drainage problems",
      "Full site clean-up after every project",
      "Residential and commercial projects welcome",
      "Compliant with local regulations and safety standards",
    ],

    processTitle: "Our Excavation Process",
    processDescription:
      "Professional excavation from site assessment to final clean-up",
    process: {
      step1: {
        title: "Site Assessment",
        description:
          "We evaluate the site, locate underground utilities, and plan the safest excavation approach.",
      },
      step2: {
        title: "Excavation Plan",
        description:
          "We outline depth, scope, and equipment needed, then confirm the plan with you before starting.",
      },
      step3: {
        title: "Excavation Work",
        description:
          "Our team executes the dig with precision equipment, following grade and depth specifications.",
      },
      step4: {
        title: "Site Clean-Up",
        description:
          "We remove all excavated material, grade the remaining area, and leave the site tidy.",
      },
    },

    ctaMiddle: {
      title: "Need Excavation Work Done Right?",
      subtitle:
        "From small residential digs to large commercial site prep, our team has the equipment and experience to deliver.",
      getQuote: "Get Free Excavation Quote",
      callNow: "Call to Discuss Your Project",
    },

    cta: {
      title: "Start Your Excavation Project Today",
      subtitle:
        "Contact us for professional excavation and site preparation services across the West Island of Montreal.",
      getQuote: "Request an Excavation Quote",
    },
  },

  // Snow Removal Service Page
  snowRemoval: {
    title: "Snow Removal Services",
    subtitle:
      "Fast, reliable driveway plowing and walkway shoveling to keep your property safe and accessible all winter long.",
    overviewTitle: "Professional Snow Removal for Driveways & Walkways",
    overviewDescription:
      "When Montreal winters hit, we keep your driveways clear and your walkways safe. Our snow removal team responds quickly after every storm, offering driveway plowing, walkway shoveling, and de-icing treatments for residential properties across the West Island.",

    features: {
      plowing: {
        title: "Driveway Plowing",
        description:
          "Efficient driveway plowing after every significant snowfall to keep your vehicle access clear.",
      },
      shoveling: {
        title: "Walkway Shoveling",
        description:
          "Hand shoveling of front walks, steps, and entry areas for safe pedestrian access.",
      },
      deicing: {
        title: "De-Icing & Salting",
        description:
          "Application of de-icing products to prevent ice buildup on driveways and walkways.",
      },
      seasonal: {
        title: "Seasonal Contracts",
        description:
          "Worry-free seasonal contracts — we monitor the weather and show up automatically after each storm.",
      },
      commercial: {
        title: "Commercial Properties",
        description:
          "Snow removal services for commercial parking lots, walkways, and entryways.",
      },
      reliable: {
        title: "Dependable Response",
        description:
          "Consistent, timely response so your property is cleared before your morning routine.",
      },
    },

    benefits: [
      "Cleared driveways and walkways after every storm",
      "Prevent slip-and-fall hazards with professional salting",
      "Seasonal contracts for automatic, stress-free service",
      "Reliable team that shows up on time, every time",
      "Residential and commercial properties served",
      "Protect your landscaping from improper snow removal",
    ],

    processTitle: "How Our Snow Removal Works",
    processDescription:
      "Straightforward, dependable service from first snowfall to spring",
    process: {
      step1: {
        title: "Sign Up for Service",
        description:
          "Contact us before the season starts to secure your spot on our snow removal route.",
      },
      step2: {
        title: "We Monitor the Weather",
        description:
          "Our team tracks storms and schedules our crews to be ready before snow accumulates.",
      },
      step3: {
        title: "Storm Response",
        description:
          "After each storm we plow your driveway, shovel your walks, and apply de-icer as needed.",
      },
      step4: {
        title: "Season-Long Peace of Mind",
        description:
          "Enjoy a clear, safe property all winter without lifting a shovel yourself.",
      },
    },

    ctaMiddle: {
      title: "Don't Get Snowed In This Winter",
      subtitle:
        "Secure your spot on our snow removal route before the season fills up.",
      getQuote: "Get a Snow Removal Quote",
      callNow: "Call to Book Your Route Spot",
    },

    cta: {
      title: "Stay Safe All Winter with Bearz",
      subtitle:
        "Contact us today for professional snow removal services across the West Island of Montreal.",
      getQuote: "Book Snow Removal Now",
    },
  },

  // Sod Installation Service Page
  sodInstallation: {
    title: "Professional Sod Installation Services",
    subtitle:
      "Transform your lawn instantly with our expert sod installation services for beautiful, healthy grass that's ready to enjoy immediately.",
    overviewTitle: "Expert Sod Installation and Lawn Transformation",
    overviewDescription:
      "Our professional sod installation services provide instant lawn transformation using premium quality sod and expert installation techniques for beautiful, healthy lawns you can enjoy right away.",

    features: {
      quality: {
        title: "Premium Sod Quality",
        description:
          "High-quality, locally sourced sod varieties for optimal growth.",
      },
      premium: {
        title: "Premium Sod Quality",
        description:
          "High-quality, locally sourced sod varieties for optimal growth.",
      },
      preparation: {
        title: "Soil Preparation",
        description:
          "Thorough soil preparation and grading for optimal sod establishment.",
      },
      installation: {
        title: "Expert Installation",
        description:
          "Professional installation techniques for seamless, beautiful results.",
      },
      varieties: {
        title: "Sod Varieties",
        description:
          "Multiple sod varieties to suit your climate and usage needs.",
      },
      watering: {
        title: "Proper Watering System",
        description:
          "Professional irrigation guidance and watering schedules for optimal sod establishment.",
      },
      aftercare: {
        title: "Post-Installation Care",
        description:
          "Comprehensive aftercare support and maintenance guidance for healthy sod establishment.",
      },
      care: {
        title: "Installation Care",
        description:
          "Complete care instructions and support for new sod establishment.",
      },
      warranty: {
        title: "Establishment Warranty",
        description: "Warranty on sod establishment for peace of mind.",
      },
    },

    benefits: [
      "Instant lawn transformation",
      "Professional installation quality",
      "Reduced lawn establishment time",
      "Enhanced property value",
      "Expert sod selection",
      "Complete care support",
    ],

    processTitle: "Our Sod Installation Process",
    processDescription:
      "Professional sod installation services for instant lawn transformation",
    process: {
      step1: {
        title: "Site Preparation",
        description:
          "We prepare your soil and grade the area for optimal sod installation.",
      },
      step2: {
        title: "Sod Selection",
        description:
          "We help you choose the best sod variety for your specific needs.",
      },
      step3: {
        title: "Professional Installation",
        description:
          "Our team installs your sod with precision for seamless results.",
      },
      step4: {
        title: "Care Instructions",
        description:
          "We provide complete care instructions for optimal sod establishment.",
      },
    },

    ctaMiddle: {
      title: "Ready for Instant Lawn Beauty?",
      subtitle:
        "Our sod installation experts are ready to transform your lawn immediately.",
      getQuote: "Get Free Sod Installation Quote",
      callNow: "Call for Lawn Assessment",
    },

    cta: {
      title: "Get Your Perfect Lawn Today",
      subtitle:
        "Contact us for professional sod installation services that will give you a beautiful lawn instantly.",
      getQuote: "Start Your Lawn Transformation",
    },
  },

  // Services Modal
  servicesModal: {
    title: "Get Your Free Quote Today!",
    subtitle: "Professional landscaping services tailored to your needs",
    benefit1: "Free consultation and detailed quote",
    benefit2: "Professional, insured service",
    benefit3: "100% satisfaction guarantee",
    getQuote: "Get Free Quote",
    callNow: "Call Now: 514-979-8020",
    disclaimer: "No obligation. Professional consultation included.",
  },

  // Floating Contact Button
  floatingContact: {
    contactUs: "Call Now",
    quickContact: "Quick Contact",
    callNow: "Call Now",
    sendEmail: "Send Email",
  },
};
